import { TextInput } from "../../../../components/TextInput";
import { SpaceBetween } from "@cloudscape-design/components";


/**
 * Renders the address input form if the user has selected options indicating they need a device shipped.
 *
 * @param bloodPressureCuff - The selected option for the blood pressure cuff question.
 * @param glucometer - The selected option for the glucometer question.
 * @param addressStreetValue - Current street address input.
 * @param setAddressStreetValue - Function to update street address input.
 * @param validAddressStreet - Whether the street address input is valid.
 * @param addressCityValue - Current city input.
 * @param setAddressCityValue - Function to update city input.
 * @param validAddressCity - Whether the city input is valid.
 * @param addressStateValue - Current state input.
 * @param setAddressStateValue - Function to update state input.
 * @param validAddressState - Whether the state input is valid.
 * @param addressZipCodeValue - Current ZIP code input.
 * @param setAddressZipCodeValue - Function to update ZIP code input.
 * @param validAddressZipCode - Whether the ZIP code input is valid.
 *
 * @returns JSX element for address form or null if no shipping is needed.
 */
function renderAddressQuestion(
    bloodPressureCuff: string,
    glucometer: string,
    addressStreetValue: string,
    setAddressStreetValue: (value: string) => void,
    validAddressStreet: boolean,
    addressCityValue: string,
    setAddressCityValue: (value: string) => void,
    validAddressCity: boolean,
    addressStateValue: string,
    setAddressStateValue: (value: string) => void,
    validAddressState: boolean,
    addressZipCodeValue: string,
    setAddressZipCodeValue: (value: string) => void,
    validAddressZipCode: boolean
): JSX.Element | null {
    const addressQuestion: JSX.Element = <SpaceBetween size='xxxs' direction='vertical'>
        <SpaceBetween size='m' direction='horizontal'>
            <div>Please enter your mailing address so that we can ship you the device(s)</div>
        </SpaceBetween>
        <TextInput
            value={addressStreetValue}
            onChange={setAddressStreetValue}
            placeholder="Street Address"
            showMessage={!validAddressStreet}
        />
        <TextInput
            value={addressCityValue}
            onChange={setAddressCityValue}
            placeholder="City"
            showMessage={!validAddressCity}
        />
        <TextInput
            value={addressStateValue}
            onChange={setAddressStateValue}
            placeholder="State"
            showMessage={!validAddressState}
        />
        <TextInput
            value={addressZipCodeValue}
            onChange={setAddressZipCodeValue}
            placeholder="Zipcode"
            type="number"
            showMessage={!validAddressZipCode}
        />
    </SpaceBetween>

    if (bloodPressureCuff === "No" || glucometer === "No") {
        return addressQuestion
    } else {
        return null;
    }
}

export default renderAddressQuestion;